import React from "react";
import { LoginForm } from "../../Components";

const Login = () => {
	return <LoginForm />;
};

export default Login;
